import script from "./ModalFeeTypeDetail.vue?vue&type=script&lang=ts&setup=true"
export * from "./ModalFeeTypeDetail.vue?vue&type=script&lang=ts&setup=true"

import "./ModalFeeTypeDetail.vue?vue&type=style&index=0&id=37a156f2&lang=scss"
import "./ModalFeeTypeDetail.vue?vue&type=style&index=1&id=37a156f2&lang=scss&scoped=true"

import exportComponent from "/apps/jenkins/workspace/client-prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-37a156f2"]])

export default __exports__